import { GlobalFeatureFlagTable } from '@frontend/wam-views';
import { Button, useModalControl } from '@frontend/design-system';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  const modalControl = useModalControl();

  return (
    <Page
      title='Global Feature Flags'
      breadcrumbs={[
        {
          label: 'Global Feature Flags',
        },
      ]}
      action={
        <Button onClick={modalControl.openModal} iconName='plus'>
          Add New Feature Flag
        </Button>
      }
    >
      <GlobalFeatureFlagTable />
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/global-feature-flags',
  component: RouteComponent,
  type: 'auth',
});
